import { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import { inkSpacingTokens } from '@ds/tokens';
import ContainerLayoutHeaderTitle from './components/ContainerLayoutHeaderTitle/ContainerLayoutHeaderTitle';

type ContainerLayoutHeaderType = {
    Title: typeof ContainerLayoutHeaderTitle;
} & FunctionComponent;

const ContainerLayoutHeaderContainer = styled.div`
    padding: ${inkSpacingTokens.spacingM} 0 ${inkSpacingTokens.spacingM} 0;
`;

const ContainerLayoutHeader: ContainerLayoutHeaderType = ({ children }) => (
    <ContainerLayoutHeaderContainer>
        <div className="container">{children}</div>
    </ContainerLayoutHeaderContainer>
);

ContainerLayoutHeader.Title = ContainerLayoutHeaderTitle;

export default ContainerLayoutHeader;
